import React from "react"

import { SearchBox } from '../common/SearchBox';
import { BreadCrumb } from '../navigation/BreadCrumb';

type PanelWithBreadCrumbAndSearchBoxProps = {
    currentPageName: string;
}

export const PanelWithBreadCrumbAndSearchBox = (props: PanelWithBreadCrumbAndSearchBoxProps) => {
    return <div className="card mb-4 wow fadeIn">

        {  /* <-- Card content --> */}
        <div className="card-body d-sm-flex justify-content-between">

            <BreadCrumb pageName={props.currentPageName}/>

            <div className="d-flex justify-content-center">
                <SearchBox />
            </div>
        </div>
    </div>
}